// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetCustomFieldsDefinitionsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  statuses?: Types.InputMaybe<Array<Types.InputMaybe<Types.StatusModel>> | Types.InputMaybe<Types.StatusModel>>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  parentEntityType?: Types.InputMaybe<Types.CustomFieldDefinitionEntityTypeModel>;
}>;

export type GetCustomFieldsDefinitionsQuery = {
  customFieldDefinitions: {
    totalCount?: number | null;
    customFieldDefinitions?: Array<CustomFieldDefinitionOnSettingsFragment | null> | null;
  };
};

export type CustomFieldDefinitionOnSettingsFragment = {
  uid: string;
  name?: string | null;
  code?: string | null;
  dataType?: Types.CustomFieldDefinitionDataTypeModel | null;
  parentEntityType?: Types.CustomFieldDefinitionEntityTypeModel | null;
  helperText?: string | null;
  status?: Types.StatusModel | null;
  multivalued?: boolean | null;
  financialObject?: boolean | null;
  calculation?: {
    evaluationType?: Types.CustomFieldDefinitionEvaluationTypeModel | null;
    expression?: string | null;
  } | null;
  parentCustomObjectDefinition?: { name?: string | null; uid: string } | null;
  customObjectDefinition?: { name?: string | null; uid: string } | null;
  group?: { uid: string; name?: string | null } | null;
  values?: Array<{
    value?: string | null;
    label?: string | null;
    code?: string | null;
    referenceId?: string | null;
  } | null> | null;
};

export const CustomFieldDefinitionOnSettingsFragmentDoc = gql`
    fragment CustomFieldDefinitionOnSettings on CustomFieldDefinitionModel {
  uid
  name
  code
  dataType
  parentEntityType
  helperText
  status
  multivalued
  financialObject
  calculation {
    evaluationType
    expression
  }
  parentCustomObjectDefinition {
    name
    uid
  }
  customObjectDefinition {
    name
    uid
  }
  group {
    uid
    name
  }
  values(query: {configurationMode: true, limit: 10}) {
    value
    label
    code
    referenceId
  }
}
    ` as unknown as DocumentNode<CustomFieldDefinitionOnSettingsFragment, unknown>;
export const GetCustomFieldsDefinitionsDocument = gql`
    query GetCustomFieldsDefinitions($search: String, $statuses: [StatusModel], $limit: Int, $offset: Int, $parentEntityType: CustomFieldDefinitionEntityTypeModel) {
  customFieldDefinitions(
    search: $search
    statuses: $statuses
    limit: $limit
    offset: $offset
    parentEntityType: $parentEntityType
  ) {
    totalCount
    customFieldDefinitions {
      ...CustomFieldDefinitionOnSettings
    }
  }
}
    ${CustomFieldDefinitionOnSettingsFragmentDoc}` as unknown as DocumentNode<
  GetCustomFieldsDefinitionsQuery,
  GetCustomFieldsDefinitionsQueryVariables
>;
